import React from "react";
import "./App.css";
//import RemediesDonuts from "./RemediesDonuts";
//import RemediesGradient from "./RemediesGradient";
//import RemediesBar from "./RemediesBar";

function App() {
  /*
  const names = ["France", "Italy", "Albania", "Greece", "Morocco", "Slovenia"];
  const colorCodes = [
    "#00B894",
    "#3498DB",
    "#9B59B6",
    "#7F00FF",
    "#FF5733",
    "#FFFF00",
    "#FFC0CB",
  ];
  const values = [25, 40, 15, 10, 10, 5];

  // Example Gradient Line data
  const dates = [
    "2024-06-01",
    "2024-06-02",
    "2024-06-03",
    "2024-06-04",
    "2024-06-05",
    "2024-06-06",
    "2024-06-07",
  ];
  const gradientValues = [
    {
      name: "Weight (kg)",
      data: [30, 45, 35, 60, 50, 70, 90],
    },
  ];

  // Example Column Chart data
  const columnValues = [
    {
      name: "Usage Count",
      data: [12, 19, 7, 15, 25, 30, 18],
    },
  ];*/

  return (
    <>
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          //background: "linear-gradient(135deg, #7F00FF, #E100FF)",
          color: "#fff",
          fontFamily: "'Poppins', sans-serif",
          flexDirection: "column",
        }}
      >
        <h1 style={{ fontSize: "4rem", marginBottom: "1rem" }}>Coming Soon</h1>
      </div>
      {/*<div>
      <main className="app-container">
       
        <div className="gridContainer">
          <div className="chart-card">
            <RemediesDonuts
              names={names}
              titleName="Average Litter per Country (units)"
              colorCodes={colorCodes}
              values={values}
              height={350}
              position="bottom"
            />
          </div>
          <div className="chart-card">
            <RemediesDonuts
              names={["Plastic", "Other"]}
              titleName="Plastic vs Other Litter (kg)"
              colorCodes={["#3498DB", "#FF5733"]}
              values={[70, 30]}
              height={350}
              position="bottom"
            />
          </div>
        </div>

     
        <div className="gridContainer">
          <div className="chart-card">
            <RemediesGradient
              dates={dates}
              titleName="Litter Collected per Event Date"
              maxValue={100}
              values={gradientValues}
              height={300}
            />
          </div>
          <div className="chart-card">
            <RemediesBar
              titleName="Participants per Country"
              areas={names}
              height={300}
              values={[
                {
                  name: "Participants",
                  data: [50, 75, 30, 40, 55, 20],
                },
              ]}
            />
          </div>
        </div>
      </main>
    </div>*/}
    </>
  );
}

export default App;
